/**
 * EMAILVERIFICATIONBANNER.JS - Hinweis zur Email-Verifizierung
 * 
 * ✅ Zeigt Banner wenn Email nicht verifiziert
 * ✅ Resend Email Button
 * ✅ Kann geschlossen werden
 * 
 * @version 1.0.0
 */

import React, { useState } from 'react';

function EmailVerificationBanner({ userEmail, isEmailVerified, onResendEmail }) {
  const [isDismissed, setIsDismissed] = useState(false);
  const [isResending, setIsResending] = useState(false);
  const [resendSuccess, setResendSuccess] = useState(false);

  // Nicht anzeigen wenn verifiziert oder geschlossen
  if (isEmailVerified || isDismissed) return null;

  const handleResend = async () => {
    setIsResending(true);
    try {
      if (onResendEmail) {
        await onResendEmail();
      }
      setResendSuccess(true);
      setTimeout(() => setResendSuccess(false), 5000);
    } catch (error) {
      console.error('Fehler beim Senden:', error);
    } finally {
      setIsResending(false);
    }
  };

  return (
    <div style={{
      background: 'linear-gradient(135deg, #fef3c7 0%, #fde68a 100%)',
      border: '1px solid #f59e0b',
      borderRadius: '12px',
      padding: '14px 20px',
      marginBottom: '20px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      flexWrap: 'wrap',
      gap: '12px'
    }}>
      {/* Icon + Text */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '12px', flex: 1 }}>
        <span style={{ fontSize: '1.4rem' }}>📧</span>
        <div>
          <div style={{ fontWeight: 600, color: '#92400e', fontSize: '0.95rem' }}>
            Bitte bestätige deine E-Mail-Adresse
          </div>
          <div style={{ color: '#a16207', fontSize: '0.85rem', marginTop: '2px' }}>
            Wir haben eine Bestätigungs-Email an <strong>{userEmail}</strong> gesendet.
          </div>
        </div>
      </div>

      {/* Actions */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
        {resendSuccess ? (
          <span style={{ color: '#059669', fontSize: '0.9rem', fontWeight: 600 }}>
            ✓ Email gesendet!
          </span>
        ) : (
          <button
            onClick={handleResend}
            disabled={isResending}
            style={{
              padding: '8px 16px',
              background: '#f59e0b',
              border: 'none',
              borderRadius: '8px',
              color: 'white',
              fontSize: '0.85rem',
              fontWeight: 600,
              cursor: isResending ? 'not-allowed' : 'pointer',
              opacity: isResending ? 0.7 : 1,
              transition: 'all 0.2s'
            }}
          >
            {isResending ? '⏳ Sende...' : '🔄 Erneut senden'}
          </button>
        )}
        
        <button
          onClick={() => setIsDismissed(true)}
          style={{
            padding: '6px 10px',
            background: 'transparent',
            border: 'none',
            borderRadius: '6px',
            color: '#92400e',
            fontSize: '1.1rem',
            cursor: 'pointer',
            opacity: 0.7
          }}
          title="Schließen"
        >
          ✕
        </button>
      </div>
    </div>
  );
}

export default EmailVerificationBanner;